
import React from 'react'
// import axios from 'axios';

 
const Header = () => {
    // const [showProfileLink, setShowProfileLink] = useState(false);
    // const [access, setAccess] = useState([]);

    // const handleInitialsHover = () => {
    //     setShowProfileLink(true);
    // };

    // const handleInitialsLeave = () => {
    //     setShowProfileLink(false);
    // };

    // const currentDomain = window.location.hostname;
    // console.log(currentDomain);
    return (
        <div className="header">
            <div className="right-admindetail">
                <p>
                    {/* <img  className="profile" onClick={handleProfileLinkClick} src={`${process.env.PUBLIC_URL}/images/bx-user.png`} alt="" /> */}
                    {/* <img src={`${process.env.PUBLIC_URL}/images/notification.png`} />
                    <span  >{props.name.charAt(0)}</span> */}
                    
                </p>
            </div>
        </div>
    )
}
 
export default Header